import type { Timestamp } from 'firebase/firestore';
import type { Comment } from '../../types';
import { CARDS, TEXT } from '../../styles/classNames';

interface CommentListProps {
  comments: Comment[];
  itemLookup?: (id: string) => string | undefined;
}

function formatDate(ts?: Timestamp) {
  try {
    return ts?.toDate?.()?.toLocaleString?.() || '';
  } catch {
    return '';
  }
}

export function CommentList({ comments, itemLookup }: CommentListProps) {
  if (comments.length === 0) {
    return <p className={TEXT.small}>No comments yet.</p>;
  }

  return (
    <div className="space-y-2">
      {comments.map((comment) => (
        <div
          key={comment.id}
          className={CARDS.nested}
        >
          <div className={`flex items-center justify-between ${TEXT.muted}`}>
            <span className="uppercase font-semibold">{comment.authorRole}</span>
            <span>{formatDate(comment.createdAt as Timestamp)}</span>
          </div>
          {comment.workoutItemId && (
            <p className="text-[11px] text-primary-600 dark:text-primary-300 font-medium">
              Exercise: {itemLookup?.(comment.workoutItemId) || comment.workoutItemId}
            </p>
          )}
          <p className={`${TEXT.body} mt-1 whitespace-pre-line`}>
            {comment.text}
          </p>
        </div>
      ))}
    </div>
  );
}
